import { SIGNUP_STEPS } from 'modules/auth/config/signup'
import { useCallback, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  useSignupStoreActions,
  useSignupStoreData,
  useSignupStoreStep,
} from '../store/useSignupStore'
import { SignupFormData } from './useSignupForm'

export const useSignupStep = () => {
  const {
    goToStep,
    goToNextStep,
    goToPreviousStep: goToPreviousStepAction,
  } = useSignupStoreActions()
  const signupData = useSignupStoreData()
  const signupStep = useSignupStoreStep()
  const { reset } = useFormContext<SignupFormData>()

  const { hasNextStep, hasPreviousStep } = useMemo(() => {
    const signupStepIndex = SIGNUP_STEPS.findIndex(
      ({ stepName }) => stepName === signupStep
    )

    return {
      hasNextStep: signupStepIndex < SIGNUP_STEPS.length - 1,
      hasPreviousStep: signupStepIndex > 0,
    }
  }, [signupStep])

  const goToPreviousStep = useCallback(() => {
    reset(signupData, {
      keepDirty: true,
      keepTouched: true,
    })
    goToPreviousStepAction()
  }, [goToPreviousStepAction, reset, signupData])

  return {
    hasNextStep,
    hasPreviousStep,
    goToNextStep,
    goToPreviousStep,
    goToStep,
  }
}
